import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import {
  type IParamsCreateContact,
  type IResponseContactHubspotIntegration,
} from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'

export class ContactHubspot extends ContactIntegrationBase<IResponseContactHubspotIntegration> {
  integration_type: 'hubspot'

  constructor(response: IResponseContactHubspotIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = 'hubspot'
    this.email = response.email
    this.national_number = response.phone
    this.mobile_phone = response.mobile_phone || ''
    this.phone = this.national_number
  }

  get params(): Partial<IParamsCreateContact> {
    const superParams = super.params
    return {
      ...superParams,
      hubspot_owner_id: this.origin.hubspot_owner_id,
    }
  }
}
